<app-column-title [column]="column"></app-column-title>

@if (currentValue) {
  @if (inputVisible == false) {
    <div class="update-button">
      {{ currentValue }}
      <i class="table-col-icon fas fa-pen" (click)="showInput()"></i>
    </div>
  }
} @else {
  @if (inputVisible == false) {
    <div class="update-button">
      Add
      <i class="table-col-icon fas fa-plus-circle" (click)="showInput(true)"></i>
    </div>
  }
}

@if (inputVisible) {
  <div class="input-group">
    <input
      type="number"
      class="form-control search-input"
      #inputValue
      [(ngModel)]="currentValue"
      (keyup.enter)="save()"
      (keydown.escape)="hideInput(true)"
      (focusout)="save()"
      placeholder="Invoice #"
      />
      <div class="input-group-append">
        <span class="input-group-text" (click)="clearInput()">
          <i class="fa fa-times"></i>
        </span>
      </div>
    </div>
  }
